
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  /**
   * Scrolls smoothly to the element with the given id.
   * @param id - The id of the target element.
   */
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (!element) {
      console.warn(`Element with id "${id}" not found.`);
      return;
    }
    element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-gray-100 ${
        isScrolled ? 'shadow-md' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/d9341b18b0ec25b73a2a0083444a8be7/cd3781bfb9ae66323e1c7ba0d9d5685e.png"
              alt="NTC Tecnologia"
              className="h-16 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap text-gray-800 hover:text-[#F5A623] hover:scale-105"
              style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' }}
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('diferenciais')}
              className="text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap text-gray-800 hover:text-[#F5A623] hover:scale-105"
              style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' }}
            >
              Diferenciais
            </button>
            <button
              onClick={() => scrollToSection('como-funciona')}
              className="text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap text-gray-800 hover:text-[#F5A623] hover:scale-105"
              style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' }}
            >
              Como Funciona
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap text-gray-800 hover:text-[#F5A623] hover:scale-105"
              style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' }}
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap text-gray-800 hover:text-[#F5A623] hover:scale-105"
              style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' }}
            >
              Contato
            </button>
            <a
              href="https://wa.me/5592991426889"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#F5A623] text-white px-7 py-3 rounded-lg text-base font-medium hover:bg-[#E09515] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
              style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)' }}
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
